const CustomSpinner = () => {
    return(
        <div className="loading">
            <div className="loader"/>
        </div>
    )
};

export default CustomSpinner;